import Repository from '../axios'


export default {
  loginWithGoogle() {
    return Repository.get(`/auth/google`)
  },
};
